<template>
  <div>
    <Row class="expand-row" v-if="!row.students || row.students.length == 0">
      <Col span="24">
          无分发学生记录
      </Col>
    </Row>

    <Row class="expand-row" v-for="(s, key) in row.students" :key="key" style="border: 1px solid #dddddd;padding:5px;">
      <Col span="2">
      <span class="expand-key">#: </span>
        <span class="expand-value">{{ key +1 }}</span>
      </Col>
      <Col span="3">
        <span class="expand-key">学生: </span>
        <span class="expand-value">{{ s.name }}</span>
      </Col>
      <Col span="3">
        <span class="expand-key">状态: </span>
        <span class="expand-value">{{ statusMap[s.homework.status] }}</span>
      </Col>
      <Col span="9">
        <span class="expand-key">作业: </span>
        <span class="expand-value">{{ s.homework.solution ? s.homework.solution : '暂无' }}</span>
      </Col>
      <Col span="2">
        <span class="expand-key">分数: </span>
        <span class="expand-value">{{ s.homework.score ? s.homework.score : '暂无'}}</span>
      </Col>
      <Col span="2" v-if="s.homework.status == 1">
        评分:
        <a @click="score(s, 'A')">A</a>
        <a @click="score(s, 'B')">B</a>
        <a @click="score(s, 'C')">C</a>
        <a @click="score(s, 'D')">D</a>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
    score: Function
  },
  data () {
    return {
      statusMap: {0: '待学生提交', 1: '待老师打分', 2: '完成'}
    }
  }
}
</script>
<style scoped>
.expand-row {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/sub-teacher-table-expand.vue